import React, { useState } from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Entry from './pages/Entry';
import SessionFlow from './pages/SessionFlow';
import History from './pages/History';
import Settings from './pages/Settings';
import Infinities from './pages/Infinities';
import Voimakortit from './pages/Voimakortit';
import Buy from './pages/Buy';
import Welcome from './pages/Welcome';
import Redeem from './pages/Redeem';
import { LicenseProvider, useLicense } from './lib/license';
import { LanguageProvider, useT } from './lib/i18n';
import InstallHint from './components/InstallHint';
import ChatCompanion from './components/ChatCompanion';

function GateLoading() {
  const { t } = useT();
  return (
    <div className="min-h-screen flex items-center justify-center fade-in" data-testid="gate-loading">
      <p className="ctl-helper text-sm slow-pulse">{t('gate.connecting')}</p>
    </div>
  );
}

function Gated({ children }) {
  const { activated, checking } = useLicense();
  if (checking || activated === null) return <GateLoading />;
  if (!activated) return <Navigate to="/buy" replace />;
  return children;
}

function HomeRoute() {
  const [inSession, setInSession] = useState(false);
  if (inSession) return <SessionFlow onExit={() => setInSession(false)} />;
  return <Entry onBegin={() => setInSession(true)} />;
}

function GatedChat() {
  // Only show the floating chat companion to users who have an activated license.
  // The free /buy, /welcome and /redeem pages stay completely free of it.
  const { activated } = useLicense();
  if (!activated) return null;
  return <ChatCompanion />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <LicenseProvider>
            <Routes>
              <Route path="/" element={<Gated><HomeRoute /></Gated>} />
              <Route path="/history" element={<Gated><History /></Gated>} />
              <Route path="/settings" element={<Gated><Settings /></Gated>} />
              <Route path="/infinities" element={<Gated><Infinities /></Gated>} />
              <Route path="/voimakortit" element={<Gated><Voimakortit /></Gated>} />
              <Route path="/buy" element={<Buy />} />
              <Route path="/welcome" element={<Welcome />} />
              <Route path="/redeem" element={<Redeem />} />
            </Routes>
            <InstallHint />
            <GatedChat />
          </LicenseProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
